import type { FC, ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

/**
 * Both `Button` and `DropdownMenuItem` set `pointer-events: none` while disabled, so a tooltip
 * mounted on the control itself can never be hovered — the explanation would disappear exactly
 * when the action is blocked. Trigger from an enabled wrapper instead.
 */
export const BlockedActionTooltip: FC<{ reason?: string; className?: string; children: ReactNode }> = ({
  reason,
  className = "inline-flex",
  children,
}) => {
  if (!reason) {
    return <>{children}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={className}>{children}</span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
};
